import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import ComponentLoader from "./component-loader";
import AdminLayout from "layouts/admin/components/admin-layout";

// MAIN
const Admin = ComponentLoader(lazy(() => import("../layouts/admin/admin")));

// ACCOUNT
const Account = ComponentLoader(
  lazy(() => import("../layouts/common/account/account"))
);
const Profile = ComponentLoader(
  lazy(() => import("../layouts/common/account/profile"))
);

const UpdatePassword = ComponentLoader(
  lazy(() => import("../layouts/common/account/update-pass"))
);

// CARD-HOLDER
const CardHolders = ComponentLoader(
  lazy(() => import("../layouts/admin/cardholder"))
);
const CardHoldersList = ComponentLoader(
  lazy(() => import("../layouts/admin/cardholder/cardholder"))
);
const Bulkmanage = ComponentLoader(
  lazy(() => import("../layouts/admin/cardholder/bulkmanage"))
);

const Reports = ComponentLoader(
  lazy(() => import("../layouts/admin/cardholder/reports"))
);

// MANAGE DESIGN
const Designs = ComponentLoader(lazy(() => import("../layouts/admin/design")));
const CreateDesign = ComponentLoader(
  lazy(() => import("../layouts/admin/design/design-form"))
);
const GroupDesign = ComponentLoader(
  lazy(() => import("../layouts/admin/design/group-design-form"))
);
const DesignList = ComponentLoader(
  lazy(() => import("../layouts/admin/design/design-table"))
);

// SETTINGS
const OrganisationSettings = ComponentLoader(
  lazy(() => import("../layouts/admin/settings/settings"))
);

// SUBSCRIPTION PLANS
const SubscriptionPlans = ComponentLoader(
  lazy(() => import("../layouts/admin/subscriptionplan"))
);

const PayByCard = ComponentLoader(
  lazy(() =>
    import(
      "../layouts/authentication/register/organisation/subscription/paybycard"
    )
  )
);

const ContactSales = ComponentLoader(
  lazy(() =>
    import(
      "../layouts/authentication/register/organisation/subscription/submiterequest"
    )
  )
);

const PaymentSuccessOkHa = ComponentLoader(
  lazy(() =>
    import(
      "../layouts/authentication/register/organisation/subscription/payment-success"
    )
  )
);

const PaymentFailed = ComponentLoader(
  lazy(() =>
    import(
      "../layouts/authentication/register/organisation/subscription/payment-failed"
    )
  )
);

const OrganisationRoutes = [
  {
    path: "",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        index: true,
        element: <Admin />,
      },

      {
        path: "account",
        element: <Account />,
        children: [
          {
            path: "",
            index: true,
            element: <Profile />,
          },
          {
            path: "password",
            element: <UpdatePassword />,
          },
        ],
      },
      {
        path: "cardholders",
        element: <CardHolders role={"account"} />,
        children: [
          {
            path: "",
            index: true,
            element: <CardHoldersList />,
          },
          {
            path: "bulkmanage",
            element: <Bulkmanage />,
          },
          {
            path: "reports",
            element: <Reports />,
          },
        ],
      },
      {
        path: "design",
        element: <Designs />,
        children: [
          {
            path: "",
            index: true,
            element: <DesignList />,
          },
          {
            path: "create",
            element: <CreateDesign />,
          },
          {
            path: "update",
            element: <CreateDesign />,
          },
          {
            path: "updategroup",
            element: <GroupDesign />,
          },
        ],
      },
      {
        path: "settings",
        element: <OrganisationSettings />,
      },

      {
        path: "*",
        element: <Navigate to={""} />,
      },
    ],
  },
  {
    path: "subscribe",
    children: [
      {
        path: "",
        element: <SubscriptionPlans />,
      },
      {
        path: "pay-by-card",
        element: <PayByCard />,
      },
      {
        path: "contact",
        element: <ContactSales />,
      },
    ],
  },
  {
    path: "payment-success",
    element: <PaymentSuccessOkHa />,
  },
  {
    path: "payment-failed",
    element: <PaymentFailed />,
  },
  {
    path: "*",
    element: <Navigate to={""} />,
  },
];

export default OrganisationRoutes;
